import { findTexture } from 'mc_pixi-fiber'
import { connect } from 'react-redux'
import { Component } from 'macguffin'
import Currency from 'macguffin/Utils/Currency'
import PropTypes from 'prop-types'
import Paylines from 'mc_full-slot_ui/components/paylines'
import BackgroundImage from "utils/BackgroundImage"
import { version, versionDate } from "../../../package.json"
const rulesLogoStyle = {
    position: "relative",
    backgroundPosition: "center"
}

require('../../css/components/info.less')
@connect(state => (
    {
        paytable: state.game.reelsConfig.paytable,
        paylines: state.game.reelsConfig.paylines,
        betamount: state.session.betAmount
    }
))

export default class Info extends Component {
    static propTypes = {
        paytable: PropTypes.array,
        paylines: PropTypes.array,
        betamount: PropTypes.number
    }
    constructor(props) {
        super(props)

        this.state = {
            highpayList: [],
            midpaylist: [],
            lowpaylist: [],
            wild: [],
            paylines: []
        }
    }
    componentWillMount() {
        const { paytable = 0, betamount = 0, paylines = 0 } = this.props
        const tempList = []
        for (let i = 0; i < paytable.length; i++) {
            const tempObject = []
            if (i % 3 === 0) {
                tempObject.symbol = paytable[i].symbol
                tempObject.payThree = (betamount / 15) * paytable[i].pay   // divided by amount of paylines
                tempObject.payFour = (betamount / 15) * paytable[i + 1].pay
                tempObject.payFive = (betamount / 15) * paytable[i + 2].pay
                tempObject.xPos = 0
                tempObject.yPos = 0
                tempList.push(tempObject)
            }
        }

        tempList.forEach((temp, i) => {
            if (i === 0) {
                this.state.wild.push(temp);
            }
            if (i <= 3 && i >= 1) {
                this.state.highpayList.push(temp)
            }
            if (i <= 6 && i >= 4) {
                this.state.midpaylist.push(temp)
            }
            if (i <= 10 && i >= 7) {
                this.state.lowpaylist.push(temp)
            }
        })
        this.state.paylines = paylines
    }

    render() {
        const path = findTexture('reel/symbols/normal/H1').baseTexture.resource.url
        const { betamount = 0, paylines } = this.props
        return (

            <div className="content-block" style={{ margin: '10px' }}>
            <BackgroundImage className="rulesMarsSymbol" assetName="loadingMars" style={rulesLogoStyle}>
                <BackgroundImage className="rulesGameLogo" assetName="loadingLogo" style={rulesLogoStyle} />
            </BackgroundImage>

            <div className="versionContainer">
                <p> {this.t(`${version} ${versionDate}`)} </p>
            </div>
            <div className="divider" />

                <h1>
                    {this.t('info.paytable')}
                </h1>
                <h3>
                    {this.t('info.currentBet')}
                    {' '}
                    {Currency.format(betamount)}
                </h3>
                <div className="flex-container">
                    {this.state.wild.map((symbol, index) => {
                        const symbolName = symbol.symbol === 'WR' ? 'WR_FS' : symbol.symbol
                        const texture = findTexture(`reel/symbols/normal/${symbolName}`)

                        return (
                            <div key={index}>
                                <div
                                  style={{
                                      width: texture._frame.width / 2,
                                      height: texture._frame.height / 2,
                                      overflow: 'hidden'
                                  }}
                                >
                                    <img
                                      src={path} alt={''} style={{
                                          width: texture.baseTexture.width / 2,
                                          height: texture.baseTexture.height / 2,
                                          marginLeft: -texture._frame.x / 2,
                                          marginTop: -texture._frame.y / 2
                                      }}
                                    />
                                </div>

                                <p style={{ position: 'relative', lineHeight: '200%', left: '15%' }}>
                  5 • {Currency.format(symbol.payFive)}<br />
                  4 • {Currency.format(symbol.payFour)}<br />
                  3 • {Currency.format(symbol.payThree)}<br />
                                </p>
                            </div>
                        )
                    })}
                </div>
                <div className="flex-container">
                    {this.state.highpayList.map((symbol, index) => {
                        const texture = findTexture(`reel/symbols/normal/${symbol.symbol}`)

                        return (
                            <div key={index}>
                                <div
                                  style={{
                                      width: texture._frame.width / 2,
                                      height: texture._frame.height / 2,
                                      overflow: 'hidden'
                                  }}
                                >
                                    <img
                                      src={path} alt={''} style={{
                                          width: texture.baseTexture.width / 2,
                                          height: texture.baseTexture.height / 2,
                                          marginLeft: -texture._frame.x / 2,
                                          marginTop: -texture._frame.y / 2
                                      }}
                                    />
                                </div>

                                <p style={{ position: 'relative', lineHeight: '200%', left: '15%' }}>
                  5 • {Currency.format(symbol.payFive)}<br />
                  4 • {Currency.format(symbol.payFour)}<br />
                  3 • {Currency.format(symbol.payThree)}<br />
                                </p>
                            </div>
                        )
                    })}
                </div>

                <div className="flex-container">
                    {this.state.midpaylist.map((symbol, index) => {
                        const texture = findTexture(`reel/symbols/normal/${symbol.symbol}`)

                        return (
                            <div key={index}>
                                <div
                                  style={{
                                      width: texture._frame.width / 2,
                                      height: texture._frame.height / 2,
                                      overflow: 'hidden'
                                  }}
                                >
                                    <img
                                      src={path} alt={''} style={{
                                          width: texture.baseTexture.width / 2,
                                          height: texture.baseTexture.height / 2,
                                          marginLeft: -texture._frame.x / 2,
                                          marginTop: -texture._frame.y / 2
                                      }}
                                    />
                                </div>

                                <p style={{ position: 'relative', lineHeight: '200%', left: '15%' }}>
                  5 • {Currency.format(symbol.payFive)}<br />
                  4 • {Currency.format(symbol.payFour)}<br />
                  3 • {Currency.format(symbol.payThree)}<br />
                                </p>
                            </div>
                        )
                    })}
                </div>

                <div className="flex-container">
                    {this.state.lowpaylist.map((symbol, index) => {
                        const texture = findTexture(`reel/symbols/normal/${symbol.symbol}`)

                        return (
                            <div key={index}>
                                <div
                                  style={{
                                      width: texture._frame.width / 2,
                                      height: texture._frame.height / 2,
                                      overflow: 'hidden'
                                  }}
                                >
                                    <img
                                      src={path} alt={'hej'} style={{
                                          width: texture.baseTexture.width / 2,
                                          height: texture.baseTexture.height / 2,
                                          marginLeft: -texture._frame.x / 2,
                                          marginTop: -texture._frame.y / 2
                                      }}
                                    />
                                </div>

                                <p style={{ position: 'relative', lineHeight: '200%', left: '15%' }}>
                  5 • {Currency.format(symbol.payFive)}<br />
                  4 • {Currency.format(symbol.payFour)}<br />
                  3 • {Currency.format(symbol.payThree)}<br />
                                </p>
                            </div>
                        )
                    })}
                </div>
                <div className="divider" />
                <h1>
                    {this.t('info.paylines')}
                </h1>
                <div className="divider" />
                <Paylines paylines={paylines} color={'#fcb101'} unlitColor={'#545250'} />
            </div>
        )
    }
}
